module.exports = __webpack_public_path__ + "static/img/img.146655c9.jpg";